export const SCA_VALIDATION_RESPONSE_PATH: string = '/account/sca/validation-response';
